import React, {Fragment} from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./optionMenu.sass";
import {OptionMenuKeyValue} from "../../../stores/observables/optionMenuKeyValue";
import {ObservableList} from "../../../stores/observables/observableList";
import {observer} from "mobx-react-lite";
import classNames from "classnames";
import {capitalize} from "../../../utils/stringUtils";

interface IOptionMenuProps {
  options: ObservableList<OptionMenuKeyValue>;
  onOptionSelected: (option: OptionMenuKeyValue) => void;
  disabled: boolean;
}

/**
 * An option menu that displays a list of options which can be applied to an selected item.
 * @param options - A list of options available to be selected.
 * @param onOptionSelected - Selected option handler.
 * @param disabled - True if the option menu should be disabled.
 */
const OptionMenu: React.FC<IOptionMenuProps> = ({
  options,
  onOptionSelected,
  disabled
}) => {
  return (
    <UncontrolledDropdown group={true} disabled={disabled}>
      <DropdownToggle
        data-testid={"optionMenu"}
        className="option-menu"
        disabled={disabled}
      >
        <FontAwesomeIcon icon={"ellipsis-h"} />
      </DropdownToggle>
      <DropdownMenu right={true}>
        {options.items &&
          options.items.map((item, index) => (
            <DropdownItem
              key={index}
              disabled={item.isDisabled}
              onClick={() => onOptionSelected(item)}
              className={classNames({
                "is-danger": item.isDanger,
                "is-disabled": item.isDisabled
              })}
            >
              <Fragment>{capitalize(item.label)}</Fragment>
            </DropdownItem>
          ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default observer(OptionMenu);
